(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papapanagioti-velorum-portal"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-velorum-hub]').forEach(function (hub) {
    var checks = Array.prototype.slice.call(hub.querySelectorAll('[data-velorum-check]'));
    if (!checks.length) return;
    var storageKey = 'velorum-standard-reset';
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (error) { saved = {}; }
    function renderProgress() {
      var complete = checks.filter(function (check) { return check.checked; }).length;
      var label = hub.querySelector('[data-velorum-progress]');
      var bar = hub.querySelector('[data-velorum-progress-bar]');
      if (label) label.textContent = complete + ' / ' + checks.length;
      if (bar) bar.style.width = ((complete / checks.length) * 100) + '%';
    }
    checks.forEach(function (check) {
      check.checked = Boolean(saved[check.dataset.velorumCheck]);
      check.addEventListener('change', function () {
        saved[check.dataset.velorumCheck] = check.checked;
        try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (error) {}
        renderProgress();
      });
    });
    renderProgress();
  });

  } catch(e) { console.error(e); }
})();
})();
